export enum MediaTypeEnum {
  RADIO = 1,
  TV = 2,
  RADIO_TV = 3,
}
